import React from "react";
import { Button, Modal, Spinner, ProgressBar, Dropdown, Form, OverlayTrigger, Tooltip, } from "react-bootstrap";
import Dropzone from "react-dropzone";
import BootstrapTable from "react-bootstrap-table-next";
import _ from "lodash";
import "../../Modules/Settings/EntityManagement/LocationTab.scss";
import { Utils } from "../../Common/Utilis";
import { toast } from "react-toastify";
// import { EntityManagementService } from "../Services/EntityManagementService";
import { resolve, reject } from "q";
import { CAType } from "../../Modules/Settings/EntityManagement/CAType";
import { CASubType } from "../../Modules/Settings/EntityManagement/CASubType";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import $ from "jquery";
import { FacilityMaintenance } from "../../Common/Services/FacilityMaintenance";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays, format, isValid, parse } from "date-fns";
import { LocationAdded } from "./LocationAdded";
import { AddProcedure } from "./AddProcedure";

export class MaintenanceScheduleBulkUpload extends React.Component<any, any> {
  private commonArea: any;
  private input: any;
  private notesInput: any;
  private roomIDInput: any;
  constructor(props: any) {
    super(props);
    this.commonArea = React.createRef();
    this.input = React.createRef();
    this.notesInput = React.createRef();
    this.roomIDInput = React.createRef();
    this.state = {
      Status: "Status",
      viewType: "guestrooms",
      isDisabled: false,
      accDateList: [],
      bulkImportModal: false,
      uploadFiles: [],
      isProgress: Math.floor(Math.random() * 30),
      BlobbaseUrl: "",
      bulkUplodedFilesData: [],
      isUploadesFiles: false,
      fileUploadedError_msg: "",
      isFileUploadedError: false,
      CASubTypeList: [],
      Allstatus: [{ frequencyUnit: "Days" }, { frequencyUnit: "Weeks" }, { frequencyUnit: "Months" }, { frequencyUnit: "Years" }],
      typeList: [],
      hidValue: this.props.hotelId,
      proceduresList: [],
      tableProceuresData:[],
      isImportData:false
    };
  }

  onBulkImport = () => {
    this.props.handleBulkImport()
    this.setState({
      uploadFiles: [], isUploadesFiles: false,
      fileUploadedError_msg: ""
    });
  }

  onBulkHide = () => {
    this.props.bulkHideModule()
    this.setState({ uploadFiles: [], fileUploadedError_msg: "" });
  }


  handleBackScreen = () => {
    if (!this.state.isUploadesFiles) {
      this.props.bulkHideModule()
      this.setState({ uploadFiles: [], fileUploadedError_msg: "" });
    } else {
      this.setState({ isUploadesFiles: false, uploadFiles: [], fileUploadedError_msg: "", bulkUplodedFilesData: [], isFileUploadedError: false });
    }
  }

  handleOnCancel = () => {
    this.props.bulkHideModule()
    this.setState({ isUploadesFiles: false, uploadFiles: [], bulkImportModal: false, fileUploadedError_msg: "", bulkUplodedFilesData: [] });
  }

  OnValidationCheck = (list: any) => {
    let copyTabletableData: any = [];
    let newTableData = [...this.state.bulkUplodedFilesData];
    copyTabletableData = Object.assign([], list);
    newTableData.map((item: any) => {

      if (item.roomname !== "") {
        let row = copyTabletableData.filter((x) => x.roomname?.toLowerCase() === item?.roomname.toLowerCase() && x.isValidName === "false");
        if (row.length > 0) {
          item.isValidName = "false";
          item.bugStatus = "Duplicate";
        }
        let row1 = copyTabletableData.filter((x) => x.roomname?.toLowerCase() === item?.roomname.toLowerCase() && x.isvalidRoomId === "false");
        if (row1.length > 0) {
          item.isvalidRoomId = "false";
          item.bugStatus = "Missing Data";
        }

      }
    });

    this.setState({ bulkUplodedFilesData: [] }, () => {
      this.setState({ bulkUplodedFilesData: newTableData })
    });
  }

  finalExcelImportInTable = () => {
    let newtableData: any = [];
    let copyTabletableData: any = [];
    let checkLocationRequired = false;

    copyTabletableData = Object.assign([], this.state.bulkUplodedFilesData);
    newtableData = Object.assign([], this.state.bulkUplodedFilesData);
    newtableData.map((item: any) => {
      if (item.name === "") {
        item.bugStatus = "Missing Data";
        item.nameValidation = true;
        checkLocationRequired = true;
      }
      if (item.description === "") {
        item.bugStatus = "Missing Data";
        item.descriptionValidation = true;
        checkLocationRequired = true;
      }
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      if (!item.startDate || new Date(item.startDate) < new Date(tomorrow.toDateString())) {
        item.bugStatus = "Missing Data";
        item.startDateValidation = true;
        checkLocationRequired = true;
      }     
      if (item.endDate) {
        const start = new Date(item.startDate);
        const end = new Date(item.endDate);
        if (isValid(start) && isValid(end) && end <= start) {
          item.bugStatus = "Missing Data";
          item.endDateValidation = true;
          checkLocationRequired = true;
        } else {
          item.endDateValidation = false;
        }
      }      
      if (item.frequencyNumber === "" || item.frequencyNumber == 0 || !/^\d{1,3}$/.test(item.frequencyNumber)) {
        item.bugStatus = "Missing Data";
        item.frequencyNumberValidation = true;
        checkLocationRequired = true;
      }
      if (!item.locations || item.locations.length === 0) {
        item.bugStatus = "Missing Data";
        item.locationValidation = true;
        checkLocationRequired = true;
      }
       if (item.locations && item.locations.length > 0) {
          item.locations = item.locations;
        }
    });
    


    newtableData.map((item: any) => {
      if (item.name !== "") {
        let oldRow = this.props.allMaintenanceSchedule.filter((x) => x.projectName.toLowerCase() === item.name.toLowerCase());
        let row = copyTabletableData.filter((x) => x.name.toLowerCase() === item.name.toLowerCase());
        
        if (item.name.length > 50) {
          if(item.bugStatus == ""){
            item.bugStatus = "NameCharactersLength";
            item.nameCharactersLengthValidation = true;
          }
          checkLocationRequired = true;
        }
        if (item.description.length > 200) {
           if(item.bugStatus == ""){
            item.bugStatus = "DescriptionCharactersLength";
            item.descriptionCharactersLengthValidation = true;
           }
          checkLocationRequired = true;
        }

        if (oldRow.length > 0) {
          checkLocationRequired = true;
            item.alllistbugStatus = "Duplicate";
        }
        else if (row.length > 1) {
          checkLocationRequired = true;
          if (item.bugStatus === "") {
            item.bugStatus = "Duplicate";
          }

        } else {
          // item.bugStatus = "";
        }
      }
    });

    // newtableData.map((item: any) => {
    //   if (item.name !== "") {
    //     let row = this.state.Allstatus.filter((x) => x.Status.toLowerCase() === item.status.toLowerCase());
    //     if (row.length == 0) {
    //       checkLocationRequired = true;
    //       if (item.bugStatus === "") {
    //         item.bugStatus = "Missing Data";
    //         item.locationStatusValidation = true
    //       }

    //     } else {
    //       //item.bugStatus = "";
    //     }
    //   }
    // });


    if (checkLocationRequired) {
      this.setState({ bulkUplodedFilesData: [] }, () => {
        this.setState({ bulkUplodedFilesData: newtableData });
      });
      return;
    } else {
      let newtableData: any = [];
      newtableData = Object.assign([], this.state.bulkUplodedFilesData);
      let requestArray: any = [];
      newtableData.map((item: any) => {
        let requestObject = {} as any;
        const parsedEndDate = item.endDate
          ? parse(item.endDate, "MM/dd/yy", new Date())
          : null;
        const formattedEndDate =
          parsedEndDate && isValid(parsedEndDate)
            ? format(parsedEndDate, "MM/dd/yyyy")
            : "";
        let storage = JSON.parse(localStorage.getItem("storage")!);
        let tenantID = storage === null ? 0 : (storage.tenantID as any);
        const scheduleMaintenanceRequest = {
          ProjectName: item.name,
          Description: item.description,
          StartDate:format(new Date(item.startDate), "MM/dd/yyyy"),
          EndDate: formattedEndDate,
          Frequency: item.frequencyNumber == 1
          ? item.frequencyUnit.replace(/s$/, '') 
          : item.frequencyUnit,
          FrequencyValue: item.frequencyNumber,
          NextStartDate: format(new Date(item.startDate), "MM/dd/yyyy"),
          AssignedTo: 0,
          Tenantid: tenantID,
          Hid: this.props.hotelId,
        };
        let procedureData: any[] = [];
        if (item.procedures && item.procedures.length > 0) {
          item.procedures.forEach((proc: any) => {
            if (proc.isChecked) { // Only add checked procedures
              procedureData.push({ ProcedureId: proc.procedureId });
            }
          });
        }
        let locationData: any[] = [];
        if (item.locations && item.locations.length > 0) {
          item.locations.forEach((loc: any) => {
            if (loc.isChecked) { // Only add checked locations
              locationData.push({ LocationId: loc.id });
            }
          });
        }
        requestObject.ScheduleMaintenanceRequest = scheduleMaintenanceRequest;
        requestObject.ProcedureIds = procedureData;
        requestObject.LocationIds = locationData;

        requestArray.push(requestObject);

      });
      this.setState({ isImportData: true });
      FacilityMaintenance.SaveBulkImportTemplate(requestArray)
        .then(async (result: any | null) => {
          if (result !== null) {
            if (result.message == "Success") {
              this.setState({bulkImportModal: false, uploadFiles: [], isUploadesFiles: false,fileUploadedError_msg: ""});
              this.props.saveBulkHideModule()
              toast.success("Maintenance Schedule saved successfully", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "MaintenceShudleSldieOut",
              });
            }
          }
          this.setState({ isImportData: false });
          resolve();
        })
        .catch((error) => {
          this.setState({ isImportData: false });
          reject();
        });





      // EntityManagementService.SaveLocationImportTemplate(requestArray)
      //   .then(async (result: any | null) => {
      //     successToastMessage = result.message;
      //     if (result != null && result.message === "Success") {
      //       this.setState({
      //         bulkImportModal: false, uploadFiles: [], isUploadesFiles: false,
      //         fileUploadedError_msg: ""
      //       });
      //       this.props.bulkHideModule()
      //       toast.success("Import successfully", {
      //         position: toast.POSITION.BOTTOM_RIGHT,
      //         containerId: "bulkLocation",
      //       });
      //     } else {
      //       // Utils.toastError(
      //       //   successToastMessage,
      //       //   {
      //       //     position: toast.POSITION.BOTTOM_RIGHT,
      //       //     containerId: "bulkLocation",
      //       //   }
      //       // );
      //       this.OnValidationCheck(result.result);                 
      //     }
      //     resolve();
      //   })
      //   .catch((err: any) => {
      //     Utils.toastError(
      //       `Server Error, ${err}`,
      //       {
      //         position: toast.POSITION.BOTTOM_RIGHT,
      //         containerId: "bulkLocation",
      //       }
      //     );
      //     reject();
      //   });

    }
  };

  handleCSVImportData = (type: any) => {
    if (type === "ImportData") {
      this.finalExcelImportInTable();
    } else {
      this.setState({ isUploadesFiles: true, fileUploadedError: "" });
    }
  }

  downloadTemplate = () => {
    FacilityMaintenance.DownloadMaintenanceScheduleTemplete(
      this.props.hotelId
    ).then(async (result: any | null) => {
      const fileName = `${"PreventativeMaintenanceTemplate"}`;
      let csvURL = window.URL.createObjectURL(result.data);
      let tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", fileName + ".csv");
      tempLink.click();
    });
  }


  handleDownloadCSV = () => {
    this.downloadTemplate();
  }

  handleRemoveFile = () => {
    this.setState({ uploadFiles: [], fileUploadedError_msg: "", isFileUploadedError: false });
  }
  onUploadProgress = (data: any) => {
    const progress: any = (
      (Number(data.loaded) / Number(data.total)) *
      100
    ).toFixed(2);
    this.setState({ fileUploadProgress: progress });
  };
  resetFiles = () => {
    this.setState({ newSelectedfiles: [], savedfiles: [], files: [] });
  };
  // normalizeDateFormat = (data: any[]) => {
  //   return data.map(item => {
  //     const startDate = item.startDate ? new Date(item.startDate) : null;
  //     const endDate = item.endDate ? new Date(item.endDate) : null;
  
  //     return {
  //       ...item,
  //       startDate: startDate && isValid(startDate) ? format(startDate, 'MM/dd/yy') : "",
  //       endDate: endDate && isValid(endDate) ? format(endDate, 'MM/dd/yy') : "",
  //     };
  //   });
  // };
  locationExcelImport = () => {
    FacilityMaintenance.SaveScheduleMaintenanceExcelImport(this.state.uploadFiles, this.props.hotelId)
      .then(async (result: any) => {
        this.setState({ isProgress: 100 });
                if (result.success) {
          let count = 0;
          let data = result?.result;
          data.map((item: any) => {
            count = count + 1;
            item.id = count;
            item.bugStatus = "";
            item.subTypeValidation = false;
            item.typeValidation = false;
            item.locationNameValidation = false;
            item.locationStatusValidation = false;
            const parsedStart = new Date(item.startDate);
            const parsedEnd = new Date(item.endDate);
            item.startDate = isValid(parsedStart) ? format(parsedStart, 'MM/dd/yy') : "";
            item.endDate = isValid(parsedEnd) ? format(parsedEnd, 'MM/dd/yy') : "";
            const parsedFrequency = parseInt(item.frequencyNumber);
            item.frequencyNumber = !isNaN(parsedFrequency) && parsedFrequency > 0 ? parsedFrequency : null;
            const validUnits = this.state.Allstatus.map(u => u.frequencyUnit.toLowerCase());
            if (validUnits.includes(item.frequencyUnit?.toLowerCase())) {
              item.frequencyUnit = item.frequencyUnit.charAt(0).toUpperCase() + item.frequencyUnit.slice(1).toLowerCase();
            } else {
              item.frequencyUnit = "Days";
            }
          });
          // const normalizedData = this.normalizeDateFormat(data);
          toast.success("File uploaded successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "bulkLocation",
            autoClose:3000
          });
          this.setState({ bulkUplodedFilesData: data, isFileUploadedError: true });
        } else {
          if (result?.message.toLocaleLowerCase() === "invalidcallname" || result?.message.toLocaleLowerCase() === "norecords") {
            this.setState({ fileUploadedError_msg: result?.result });
          }
        }

        resolve();

      }).catch((error) => {
        Utils.toastError("No Records are available to import.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });

        reject();
      });
  };

  gUestStatusChangesData = (row: any, rowIndex: any, item: any) => {
    const newTableData = this.state.bulkUplodedFilesData.map((d) => {
      //if (d.id === row.id) {
      if (d.id === row.id) {
        return {
          ...d,
          frequencyUnit: item.frequencyUnit,
          locationStatusValidation: false,
          bugStatus: "",
        };
      }
      return d;
    });
    this.setState({ bulkUplodedFilesData: newTableData })

  };

  // subTypeSelected = (item: any, row: any) => {
  //   const newTableData = this.state.bulkUplodedFilesData.map((d) => {
  //     if (d.id === row.id) {
  //       return {
  //         ...d,
  //         subTypeName: item.subTypeName,
  //         subTypeID: item.uniqueno,
  //         subTypeValidation: false,
  //         bugStatus: "",
  //       };
  //     }
  //     return d;
  //   });
  //   this.setState({ bulkUplodedFilesData: newTableData });
  // };

  // typeSelected = (item: any, row: any) => {
  //   const newTableData = this.state.bulkUplodedFilesData.map((d) => {
  //     //if (d.id === row.id) {
  //     if (d.id === row.id) {
  //       return {
  //         ...d,
  //         typeName: item.typeName,
  //         typeID: item.typeID,
  //         typeValidation: false,
  //         subTypeName: "",
  //         bugStatus: "",
  //       };
  //     }
  //     return d;
  //   });
  //   this.commonArea.current?.callFromParent();
  //   this.setState({ bulkUplodedFilesData: newTableData, typeId: item.typeID, isAdded: true, })

  // };

  // onNameChange = (e: any, row: any, rowIndex: any) => {
  //   debugger
  //   let inputId = `${rowIndex}name`;
  //   let value = e.target.value;
  //   let cursorIndex = e.target.selectionStart;
  //   let newTableData = [...this.state.bulkUplodedFilesData];
  //   newTableData = newTableData.map((d) => {
  //     if (d.id === row.id) {
  //       return {
  //         ...d,
  //         name: value,
  //         bugStatus: "",
  //         locationNameValidation: false,
  //       };
  //     } else {
  //       return d;
  //     }
  //   });
  //   this.setState(
  //     (curr: any) => ({
  //       ...curr,
  //       bulkUplodedFilesData: newTableData,
  //     }),
  //     () => {
  //       $("#" + inputId)
  //         .focus()
  //         .prop("selectionEnd", cursorIndex);
  //       this.input.current.focus();
  //     }
  //   );
  // }
  checkForDuplicates = () => {
  const updatedData = [...this.state.bulkUplodedFilesData];
  let isDuplicateFound = false;
  updatedData.forEach((row, index) => {
    if (row.name !== "") {
      const duplicateRow = updatedData.filter((item, idx) => 
        idx !== index && item.name.toLowerCase() === row.name.toLowerCase()
      );

      if (duplicateRow.length > 0) {
        updatedData[index] = { ...row, bugStatus: row.name.length > 50 ? "NameCharactersLength" : "Duplicate" , nameCharactersLengthValidation : row.name.length > 50 ? true : false, nameValidation: true };
        isDuplicateFound = true;
      } else {
        updatedData[index] = { ...row, bugStatus: row.name.length > 50 ? "NameCharactersLength" : row.bugStatus == "DescriptionCharactersLength" ? "DescriptionCharactersLength" : "", nameCharactersLengthValidation : row.name.length > 50 ? true : false, nameValidation: false };
      }
    }
  });
  this.setState({ bulkUplodedFilesData: updatedData });
};
checkForDescription = () => {
  const updatedData = [...this.state.bulkUplodedFilesData];
  updatedData.forEach((row, index) => {
    if (row.description !== "") {
      if (row.description.length > 200) {
        updatedData[index] = {
          ...row,
          bugStatus: "DescriptionCharactersLength", 
          descriptionCharactersLengthValidation: true, 
        };
      } else {
        updatedData[index] = {
          ...row,
          bugStatus: "", 
          descriptionCharactersLengthValidation: false, 
        };
      }
    }
  });
  this.setState({ bulkUplodedFilesData: updatedData });
};

  onNameChange = (e: any, row: any, rowIndex: any) => {
    const value = e.target.value;
    const updatedData = this.state.bulkUplodedFilesData.map(d =>
      d.id === row.id ? { ...d, name: value, nameValidation: false, bugStatus: "" ,alllistbugStatus:""} : d
    ); 
      this.setState({ bulkUplodedFilesData: updatedData }, () => {
    this.checkForDuplicates();
  });
    // this.setState({ bulkUplodedFilesData: updatedData });
  };

  onDescriptionChange = (e: any, row: any, rowIndex: any) => {
    const value = e.target.value;
    const updatedData = this.state.bulkUplodedFilesData.map(d =>
      d.id === row.id ? { ...d, description: value,descriptionValidation:false,bugStatus:"" } : d
    );
    this.setState({ bulkUplodedFilesData: updatedData },()=>{
      this.checkForDescription();
    });
  };
  handleFormattedDateChange = (date: Date, row: any, field: string) => {
    if (!isValid(date)) {
      const updatedData = this.state.bulkUplodedFilesData.map(d => {
        if (d.id === row.id) {
          let updatedRow: any = { ...d, [field]: null };
          if (field === 'endDate') {
            updatedRow.endDateValidation = false;
          }
          return updatedRow; 
        }
        return d; // Return unchanged row
      });
  
      this.setState({ bulkUplodedFilesData: updatedData });
      return;
    }
    const formattedDate = format(date, 'MM/dd/yy');
    const updatedData = this.state.bulkUplodedFilesData.map(d => {
      if (d.id === row.id) {
        let updatedRow: any = { ...d, [field]: formattedDate };
        if (field === 'startDate') {
          const startDate = parse(formattedDate, 'MM/dd/yy', new Date());
          const endDate = d.endDate && isValid(new Date(d.endDate))
          ? parse(d.endDate, 'MM/dd/yy', new Date())
          : null;
          if (endDate && endDate <= startDate) {
            updatedRow.endDate = null;
          }
          updatedRow.startDateValidation = false;
          updatedRow.endDateValidation = false;
          updatedRow.bugStatus = "";
        }
        if(field === 'endDate'){
          updatedRow.endDateValidation = false;
        }
        return updatedRow;
      }
      return d;
    });
  
    this.setState({ bulkUplodedFilesData: updatedData });
  };
  
  onFrequencyNumberChange = (e: any, row: any, rowIndex: any) => {
    const value = e.target.value;
    const updatedData = this.state.bulkUplodedFilesData.map(d =>
      d.id === row.id ? { ...d, frequencyNumber: value,frequencyNumberValidation:false,bugStatus: "" } : d
    );
    this.setState({ bulkUplodedFilesData: updatedData });
  };

  // onNotesChange = (e: any, row: any, rowIndex: any) => {
  //   let inputId = `${rowIndex}notes`;
  //   let value = e.target.value;
  //   let cursorIndex = e.target.selectionStart;
  //   let newTableData = [...this.state.bulkUplodedFilesData];
  //   newTableData = newTableData.map((d) => {
  //     if (d.id === row.id) {
  //       return {
  //         ...d,
  //         notes: value,
  //       };
  //     } else {
  //       return d;
  //     }
  //   });
  //   this.setState(
  //     (curr: any) => ({
  //       ...curr,
  //       bulkUplodedFilesData: newTableData,
  //     }),
  //     () => {
  //       $("#" + inputId)
  //         // .focus()
  //         .prop("selectionEnd", cursorIndex);
  //       this.notesInput.current.focus();
  //     }
  //   );
  // }

  // onRoomIdChange = (e: any, row: any, rowIndex: any) => {
  //   let inputId = `${rowIndex}roomID`;
  //   let value = e.target.value;
  //   let cursorIndex = e.target.selectionStart;
  //   let newTableData = [...this.state.bulkUplodedFilesData];
  //   newTableData = newTableData.map((d) => {
  //     if (d.id === row.id) {
  //       return {
  //         ...d,
  //         roomID: value,
  //       };
  //     } else {
  //       return d;
  //     }
  //   });
  //   this.setState(
  //     (curr: any) => ({
  //       ...curr,
  //       bulkUplodedFilesData: newTableData,
  //     }),
  //     () => {
  //       $("#" + inputId)
  //         // .focus()
  //         .prop("selectionEnd", cursorIndex);
  //       this.roomIDInput.current.focus();
  //     }
  //   );
  // }

  CAName = (cell: any, row: any, rowIndex: any) => {
    return (
      <div className="email-formatter">
        <Form.Group>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 100, hide: 200 }}
          overlay={
            <Tooltip id={"name"} className={row.name?.length > 24 ? "d-block" : "d-none"}>
              {row.name}
            </Tooltip>
          }>
          <Form.Control
            ref={this.input}
            className={row.bugStatus === "Duplicate" || row.alllistbugStatus === "Duplicate" || row.nameValidation === true || row.nameCharactersLengthValidation === true ? "alert-danger" : ""}
            id={`${rowIndex}name`}
            //placeholder="-" 
            value={row.name}
            // disabled={!this.props.parentState.permissionManageSettings}
            onChange={(e: any) => this.onNameChange(e, row, rowIndex)}
            // onBlur={(e: any) => this.onEmailBlur(e, row, rowIndex)}
            maxLength={50}
            autoComplete="Off"
          />
        </OverlayTrigger>
        </Form.Group>
        
      </div>
    );
  };
  CADescription = (cell: any, row: any, rowIndex: any) => {
    return (
      <div className="email-formatter">
        <Form.Group>
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 100, hide: 200 }}
            overlay={
              <Tooltip id={"description"} className={row.description?.length > 30 ? "d-block" : "d-none"}>
                {row.description}
              </Tooltip>
            }>
            <Form.Control
              ref={this.input}
              className={row.descriptionValidation === true ||  row.descriptionCharactersLengthValidation === true ? "alert-danger" : ""}
              id={`${rowIndex}description`}
              //placeholder="-" 
              value={row.description}
              // disabled={!this.props.parentState.permissionManageSettings}
              onChange={(e: any) => this.onDescriptionChange(e, row, rowIndex)}
              // onBlur={(e: any) => this.onEmailBlur(e, row, rowIndex)}
              maxLength={200}
              autoComplete="Off"
            />
          </OverlayTrigger>
        </Form.Group>
      </div>
    );
  };
  CAStartDate = (cell: any, row: any, rowIndex: any) => {
    const selectedDate = row.startDate && isValid(new Date(row.startDate))
  ? parse(row.startDate, 'MM/dd/yy', new Date())
  : null;
    return (
      <div className="email-formatter position-relative calender-picker input-form-calender">
        
        
        <DatePicker
          selected={selectedDate}
          onChange={(date: Date) => this.handleFormattedDateChange(date, row, 'startDate')}
          dateFormat="MM/dd/yy"
          className={row.startDateValidation === true ? "alert-danger form-control bg-transparent w-100" : "form-control bg-transparent w-100"}
          placeholderText="MM/DD/YY"
          minDate={addDays(new Date(), 1)}
          dayClassName={(date) => 
            date < new Date() ? "disabled-date" : undefined
          }
        />
      <div className="icon">
        <span className="calender-icon">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z"></path>
            <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z"></path>
          </svg>
        </span>
      </div>
    </div>
    );
  };
  CAEndDate = (cell: any, row: any, rowIndex: any) => {
    const selectedDate = row.endDate ? parse(row.endDate, 'MM/dd/yy', new Date()) : null;
    const startDate = row.startDate ? parse(row.startDate, 'MM/dd/yy', new Date()) : null;
    const handleCloseClick = () => {
      const updatedData = this.state.bulkUplodedFilesData.map(d => {
        if (d.id === row.id) {
          return {
            ...d,
            endDate: null, // Set End Date to null
            endDateValidation: false, // Reset validation flag
          };
        }
        return d;
      });
      this.setState({ bulkUplodedFilesData: updatedData });
    };
    return (
      <div className="email-formatter position-relative calender-picker input-form-calender">
        <DatePicker
          selected={selectedDate}
          onChange={(date: Date) => this.handleFormattedDateChange(date, row, 'endDate')}
          dateFormat="MM/dd/yy"
          className={row.endDateValidation === true ? "alert-danger form-control bg-transparent w-100" : "form-control bg-transparent w-100"}
          placeholderText="MM/DD/YY"
          minDate={startDate ? addDays(startDate, 1) : new Date()}
          dayClassName={(date) => 
            date < (startDate ? addDays(startDate, 1) : new Date()) ? "disabled-date" : undefined
          }
        />
        <div className="icon">
          <span className="calender-icon">
          {/* {row.endDate && (
            <svg onClick={handleCloseClick} xmlns="http://www.w3.org/2000/svg" className="mr-1" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M1 1L9 9M1 9L9 1" stroke="#84888C" stroke-width="2"/>
            </svg>
          )} */}
            <svg 
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z"></path>
              <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z"></path>
            </svg>
          </span>
        </div>
      </div>
    );
  };



  // CAEndDate = (cell: any, row: any, rowIndex: any) => {
  //   return (
  //     <div className="email-formatter">
  //       <Form.Group>
  //         <Form.Control
  //           type="date"
  //           className={row.bugStatus === "Duplicate" || row.locationNameValidation === true ? "alert-danger" : ""}
  //           id={`${rowIndex}endDate`}
  //           value={row.endDate || ""}
  //           onChange={(e: any) => this.handleDateChange(e, row, rowIndex, 'endDate')}
  //         />
  //       </Form.Group>
  //     </div>
  //   );
  // };
  CAFrequencyNumber = (cell: any, row: any, rowIndex: any) => {
    return (
      <div className="email-formatter">
        <Form.Group>
          <Form.Control
            ref={this.input}
            className={ row.locationNameValidation === true ? "alert-danger" : ""}
            id={`${rowIndex}frequencyNumber`}
            //placeholder="-" 
            value={row.frequencyNumber}
            // disabled={!this.props.parentState.permissionManageSettings}
            onChange={(e: any) => this.onFrequencyNumberChange(e, row, rowIndex)}
            // onBlur={(e: any) => this.onEmailBlur(e, row, rowIndex)}
            max={50}
            autoComplete="Off"
          />
        </Form.Group>
      </div>
    );
  };
  // CAFrequencyUnit = (cell: any, row: any, rowIndex: any) => {
  //   return (
  //     <div className="email-formatter">
  //       <Form.Group>
  //         <Form.Control
  //           ref={this.input}
  //           className={row.bugStatus === "Duplicate" || row.locationNameValidation === true ? "alert-danger" : ""}
  //           id={`${rowIndex}name`}
  //           //placeholder="-" 
  //           value={row.frequencyUnit}
  //           // disabled={!this.props.parentState.permissionManageSettings}
  //           onChange={(e: any) => this.onNameChange(e, row, rowIndex)}
  //           // onBlur={(e: any) => this.onEmailBlur(e, row, rowIndex)}
  //           max={50}
  //           autoComplete="Off"
  //         />
  //       </Form.Group>
  //     </div>
  //   );
  // };
  CAFrequencyUnit = (cell: any, row: any, rowIndex: any) => {
    return (
      <div className="payrollExport d-flex">
        <Form.Group>
          <Form.Control
            ref={this.input}
            className={row.frequencyNumberValidation === true ? "alert-danger" : ""}
            id={`${rowIndex}name`}
            //placeholder="-" 
            value={row.frequencyNumber}
            // disabled={!this.props.parentState.permissionManageSettings}
            onChange={(e: any) => {
              const value = e.target.value;
              // Allow only digits
              if (/^\d*$/.test(value) && value !== "0") {
                this.onFrequencyNumberChange(e, row, rowIndex);
              }
            }}
            // onBlur={(e: any) => this.onEmailBlur(e, row, rowIndex)}
            maxLength={3}
            autoComplete="Off"
            type="text"
            inputMode="numeric"
          />
        </Form.Group>
        <Dropdown className="w-100">
          <Dropdown.Toggle
            id="dropdown-importFrom"
            className=""
            // className={row.locationStatusValidation == true ? "alert-danger" : ""}
          // disabled={!this.props.parentState.permissionManageSettings}
          >
            <EllipsisWithTooltip placement="bottom">{row.frequencyUnit}</EllipsisWithTooltip>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {this.state.Allstatus.map((item: any, idx: any) => (
              <Dropdown.Item
                key={idx}
                onClick={() => {
                  this.gUestStatusChangesData(row, rowIndex, item);
                }}
                className={""}
              >
                <EllipsisWithTooltip placement="bottom">{item.frequencyUnit}</EllipsisWithTooltip>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
  selectLocationList = (locationList: any, rowIndex: number) => {
    const updatedData = this.state.bulkUplodedFilesData.map((row, index) => {
      if (index === rowIndex) {
        return {
          ...row,
          locations: locationList,
          locationValidation: locationList.length === 0, // true if none selected
          bugStatus: locationList.length === 0 ? 'Missing Data' : '',
        };
      }
      return row;
    });
  
    this.setState({ bulkUplodedFilesData: updatedData });
  };
  
  
  
  locationAdded = (item: any, type: any, rowIndex: number) => {
    const updatedData = [...this.state.bulkUplodedFilesData];
    updatedData[rowIndex].selectedLocations = item;
    this.setState({ bulkUplodedFilesData: updatedData });
  };
  scrollToDropDown = () => {
    // this.props.scrollToDropDown()
  }
  CALocations = (cell: any, row: any, rowIndex: any) => {
    const hasError = row.locationValidation;
    return (
      <div   className="align-items-center justify-content-between"
      style={{
        border: hasError ? '1px solid red' : undefined,
        borderRadius: hasError ? '4px' : undefined,
        padding: hasError ? '4px' : undefined,
      }}>
        <LocationAdded
          parentState={this.state}
          locationAdded={(item, type) => this.locationAdded(item, type, rowIndex)}
          selectLocationList={(list) => this.selectLocationList(list, rowIndex)}
          disabled={this.props.disabled}
          scrollToDropDown={this.scrollToDropDown}
          pageType="MaintenanceSchudleBulkUpload"
          rowIndex={rowIndex}
        />
      </div>
    );
  };
  procedureAdded = (item: any, rowIndex: number) => {
    const updatedData = [...this.state.bulkUplodedFilesData];
    updatedData[rowIndex].selectedProcedures = item;
    this.setState({ bulkUplodedFilesData: updatedData });
  };
  
  selectProcedureList = (procedureList: any, rowIndex: number) => {
    const updatedData = [...this.state.bulkUplodedFilesData];
    updatedData[rowIndex].procedures = procedureList;
    this.setState({ bulkUplodedFilesData: updatedData });
  };
  
  CAProcedures = (cell: any, row: any, rowIndex: any) => {
    return (
      <div className="align-items-center justify-content-between procedure-dropdown">
      <AddProcedure
      parentState={this.state}
      selectProcedureList={(list: any) => this.selectProcedureList(list, rowIndex)}
      // procedureAdded={(item: any) => this.procedureAdded(item, rowIndex)}
      pageType="MaintenanceSchudleBulkUpload"
      assetTypes={this.props.assetTypes}
      selectedProcedures={row.selectedProcedures || []}
      procedures={row.procedures || []}
      disabled={this.props.disabled}
      rowIndex={rowIndex}
    />
     </div>
    );
  };
  CARemove = (cell: any, row: any, rowIndex: any) => {
    return (
      <button
        className="btn btn-link p-0 remove-icon mr-1"
        onClick={() => this.handleRemoveRow(rowIndex)}
        title="Remove Row"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          viewBox="0 0 16 16"
          className="text-danger"
        >
          <path d="M5.5 5.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5zm2.5.5a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0v-6zM11 6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6A.5.5 0 0 1 11 6z"/>
          <path
            fillRule="evenodd"
            d="M14.5 3a1 1 0 0 1-1-1h-11a1 1 0 0 1-1 1H1v1h1v9a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4h1V3h-1.5zm-1 1v9a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V4h10zM5.5 1h5a.5.5 0 0 1 .5.5V2h-6v-.5a.5.5 0 0 1 .5-.5z"
          />
        </svg>
      </button>
    );
  };
  handleRemoveRow = (rowIndex: number) => {
    const updatedData = [...this.state.bulkUplodedFilesData];
    updatedData.splice(rowIndex, 1); // remove row at given index
    this.setState({ bulkUplodedFilesData: updatedData });
  };
  // bugStatus = (cell: any, row: any, rowIndex: any) => {
  //   return (
  //     <div className={row.bugStatus !== "" ? "email-formatter alert-danger" : "email-formatter"}>
  //       {row.bugStatus}
  //     </div>
  //   );
  // };

  // roomId = (cell: any, row: any, rowIndex: any) => {
  //   return(
  //   <div>
  //         {/* {row.roomID} */}
  //     <Form.Group className="p-0">
  //       <OverlayTrigger
  //         placement="top"
  //         delay={{ show: 100, hide: 200 }}
  //         overlay={
  //           <Tooltip id={"roomID"} className={row.roomID?.length > 9 ? "d-block" : "d-none"}>
  //             {row.roomID}
  //           </Tooltip>
  //         }>
  //         <Form.Control
  //           // ref={this.input}
  //           id={`${rowIndex}roomID`}
  //           ref={this.roomIDInput} 
  //           className={row.isvalidRoomId === "false" ? "email-formatter alert-danger" : "email-formatter"}
  //           //id={rowIndex}
  //           autoComplete="Off"
  //           value={row.roomID}

  //           onChange={(e: any) => this.onRoomIdChange(e, row, rowIndex)}
  //         />
  //         </OverlayTrigger>
  //       </Form.Group>
  //   </div>
  //       );
  // };
  onDrop = (uploadFiles: any) => {
    let size = 10485760;
    if (uploadFiles.length === 1) {
      if (uploadFiles[0].size > size) {
        this.setState({ fileUploadedError_msg: "File exceeds 10MB limit." });
      } else {
        this.setState({ uploadFiles }, () => {
          this.setState({ loader: true });
          this.locationExcelImport();
          // this.getFileSize();
        });
      }

    } else if (uploadFiles.length > 1) {
      Utils.toastError("Multiple files are not allowed.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "bulkLocation",
      });
    } else {
      Utils.toastError("Please upload a CSV file.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "bulkLocation",
      });
    }
  };



  render() {
    
    let bulkUplodedFilesData = [...this.state.bulkUplodedFilesData]
    let isMissingData = bulkUplodedFilesData.filter((x) => x.bugStatus === "Missing Data");
    let isDuplecateData = bulkUplodedFilesData.filter((x) => x.bugStatus === "Duplicate");
    let isNameCharactersLength = bulkUplodedFilesData.filter((x) => x.bugStatus === "NameCharactersLength");
    let isDescriptionCharactersLength = bulkUplodedFilesData.filter((x) => x.bugStatus === "DescriptionCharactersLength");
    let isalllistbugStatus = bulkUplodedFilesData.filter((x) => x.alllistbugStatus === "Duplicate");

    const files = this.state.uploadFiles.map((file) => (
      <li key={file.name}>
        <div className="d-flex align-items-center">
          <div className="file-name">{file.name}</div>
          <div className="file-loader mr-auto">
            <ProgressBar variant="success" now={this.state.isProgress} />
          </div>
          {/* <div className="file-percentage">{this.state.isProgress} %</div> */}
          <button className="remove-btn" onClick={this.handleRemoveFile} >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
              <path d="M13.2997 1.20997C12.9097 0.819971 12.2797 0.819971 11.8897 1.20997L6.99973 6.08997L2.10973 1.19997C1.71973 0.809971 1.08973 0.809971 0.699727 1.19997C0.309727 1.58997 0.309727 2.21997 0.699727 2.60997L5.58973 7.49997L0.699727 12.39C0.309727 12.78 0.309727 13.41 0.699727 13.8C1.08973 14.19 1.71973 14.19 2.10973 13.8L6.99973 8.90997L11.8897 13.8C12.2797 14.19 12.9097 14.19 13.2997 13.8C13.6897 13.41 13.6897 12.78 13.2997 12.39L8.40973 7.49997L13.2997 2.60997C13.6797 2.22997 13.6797 1.58997 13.2997 1.20997Z" fill="#6A6E73" />
            </svg>
          </button>
        </div>
      </li>
    ));

    const columns = [
      {
        dataField: "Name",
        text: "Name",
        editable: false,
        headerClasses: '',
        classes: '',
        formatter: this.CAName,
      },
      {
        dataField: "Description",
        text: "Description",
        editable: false,
        headerClasses: '',
        classes: '',
        formatter: this.CADescription,
      },
      {
        dataField: "StartDate",
        text: "Start Date",
        editable: false,
        headerClasses: '',
        classes: '',
        formatter: this.CAStartDate,
      },
      {
        dataField: "EndDate",
        text: "End Date",
        editable: false,
        headerClasses: '',
        classes: '',
        formatter: this.CAEndDate,
      },
      // {
      //   dataField: "FrequencyNumber",
      //   text: "Frequency Number",
      //   editable: false,
      //   headerClasses: 'width-10',
      //   classes: 'width-10',
      //   formatter: this.CAFrequencyNumber,
      // },
      {
        dataField: "Frequency",
        text: "Frequency",
        editable: false,
        headerClasses: '',
        classes: '',
        formatter: this.CAFrequencyUnit,
      },
      {
        dataField: "Locations",
        text: "Locations",
        editable: false,
        headerClasses: '',
        classes: '',
        formatter: this.CALocations,
      },
      {
        dataField: "Procedures",
        text: "Procedures",
        editable: false,
        headerClasses: '',
        classes: '',
        formatter: this.CAProcedures,
      },
      {
        dataField: "",
        text: "",
        editable: false,
        headerClasses: '',
        classes: '',
        formatter: this.CARemove,
      },
    ];

    return (
      <Modal
        className="import-credit-card-result-modal importJournalModal location-bulk-import maintenance-schedule-import-modal"
        centered
        show={this.props.bulkImportModal}
        onHide={this.props.bulkHideModule}
        backdrop="static"
        dialogClassName="modal-100w"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title>
          Preventative Maintenance Import
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={this.state.isUploadesFiles == false ? "center-content" : ""}>
          {/* Success mssg */}
          {this.state.bulkUplodedFilesData.length != 0 && this.state.isUploadesFiles && isMissingData.length === 0 && isDuplecateData.length === 0 && isalllistbugStatus.length === 0 && isNameCharactersLength.length == 0 && isDescriptionCharactersLength.length == 0 && (
            <div className="mssg">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM14.59 5.58L8 12.17L5.41 9.59L4 11L8 15L16 7L14.59 5.58Z" fill="#0E9074" />
              </svg>
              <span>Success! Please assign locations and procedures.</span>
            </div>
          )}

          {isMissingData.length > 0 && (
            <div className="mssg error">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM14.59 5.58L8 12.17L5.41 9.59L4 11L8 15L16 7L14.59 5.58Z" fill="#0E9074" />
              </svg>
              <span>{isMissingData.length} Errors Found. Please Revise.</span>
            </div>
          )}

          {isDuplecateData.length > 0 && (
            <div className="mssg duplicate">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12.0001 5.49372L19.5301 18.5037H4.47012L12.0001 5.49372ZM2.74012 17.5037C1.97012 18.8337 2.93012 20.5037 4.47012 20.5037H19.5301C21.0701 20.5037 22.0301 18.8337 21.2601 17.5037L13.7301 4.49372C12.9601 3.16372 11.0401 3.16372 10.2701 4.49372L2.74012 17.5037ZM11.0001 10.5037V12.5037C11.0001 13.0537 11.4501 13.5037 12.0001 13.5037C12.5501 13.5037 13.0001 13.0537 13.0001 12.5037V10.5037C13.0001 9.95372 12.5501 9.50372 12.0001 9.50372C11.4501 9.50372 11.0001 9.95372 11.0001 10.5037ZM11.0001 15.5037H13.0001V17.5037H11.0001V15.5037Z" fill="#863A02" />
              </svg>
              <span>{isDuplecateData.length} Duplicates Found. Please Revise.</span>
            </div>
          )}
          {isNameCharactersLength.length > 0 && (
            <div className="mssg duplicate">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12.0001 5.49372L19.5301 18.5037H4.47012L12.0001 5.49372ZM2.74012 17.5037C1.97012 18.8337 2.93012 20.5037 4.47012 20.5037H19.5301C21.0701 20.5037 22.0301 18.8337 21.2601 17.5037L13.7301 4.49372C12.9601 3.16372 11.0401 3.16372 10.2701 4.49372L2.74012 17.5037ZM11.0001 10.5037V12.5037C11.0001 13.0537 11.4501 13.5037 12.0001 13.5037C12.5501 13.5037 13.0001 13.0537 13.0001 12.5037V10.5037C13.0001 9.95372 12.5501 9.50372 12.0001 9.50372C11.4501 9.50372 11.0001 9.95372 11.0001 10.5037ZM11.0001 15.5037H13.0001V17.5037H11.0001V15.5037Z" fill="#863A02" />
              </svg>
              <span>{isNameCharactersLength.length} Field Name cannot be longer than 50 characters.</span>
            </div>
          )}
          {isDescriptionCharactersLength.length > 0 && (
            <div className="mssg duplicate">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12.0001 5.49372L19.5301 18.5037H4.47012L12.0001 5.49372ZM2.74012 17.5037C1.97012 18.8337 2.93012 20.5037 4.47012 20.5037H19.5301C21.0701 20.5037 22.0301 18.8337 21.2601 17.5037L13.7301 4.49372C12.9601 3.16372 11.0401 3.16372 10.2701 4.49372L2.74012 17.5037ZM11.0001 10.5037V12.5037C11.0001 13.0537 11.4501 13.5037 12.0001 13.5037C12.5501 13.5037 13.0001 13.0537 13.0001 12.5037V10.5037C13.0001 9.95372 12.5501 9.50372 12.0001 9.50372C11.4501 9.50372 11.0001 9.95372 11.0001 10.5037ZM11.0001 15.5037H13.0001V17.5037H11.0001V15.5037Z" fill="#863A02" />
              </svg>
              <span>{isDescriptionCharactersLength.length} Field Description cannot be longer than 200 characters.</span>
            </div>
          )}
          {isalllistbugStatus.length > 0 && (
            <div className="mssg duplicate">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12.0001 5.49372L19.5301 18.5037H4.47012L12.0001 5.49372ZM2.74012 17.5037C1.97012 18.8337 2.93012 20.5037 4.47012 20.5037H19.5301C21.0701 20.5037 22.0301 18.8337 21.2601 17.5037L13.7301 4.49372C12.9601 3.16372 11.0401 3.16372 10.2701 4.49372L2.74012 17.5037ZM11.0001 10.5037V12.5037C11.0001 13.0537 11.4501 13.5037 12.0001 13.5037C12.5501 13.5037 13.0001 13.0537 13.0001 12.5037V10.5037C13.0001 9.95372 12.5501 9.50372 12.0001 9.50372C11.4501 9.50372 11.0001 9.95372 11.0001 10.5037ZM11.0001 15.5037H13.0001V17.5037H11.0001V15.5037Z" fill="#863A02" />
              </svg>
              <span>{isalllistbugStatus.length} Duplicates Found In System. Please Revise.</span>
            </div>
          )}

          {!this.state.isUploadesFiles && (
            <div className="content">
              <div className="upload-box">
                <div className="box">
                  <h6>Step 1: Download and Complete Template </h6>
                  <Button className="w-100" onClick={this.handleDownloadCSV} >Download Template</Button>
                </div>
                <div className="box m-0">
                  <h6>Step 2: Upload Completed Template</h6>
                  {/* {!this.state.isUploadedJournal ? ( */}
                  <Dropzone
                    onDrop={this.onDrop}
                    accept=".csv"
                    multiple={false}
                  >
                    {({
                      getRootProps,
                      getInputProps,
                      isDragActive,
                      isDragReject,
                    }) => (
                      <>
                        {this.state.uploadFiles.length == 0 && (
                          <>
                            <section
                              className={
                                isDragActive
                                  ? "container upload-area default drag-active "
                                  : "container upload-area default"
                              }
                            >
                              <div
                                {...getRootProps({
                                  className: "dropzone",
                                })}
                              >
                                <input {...getInputProps()} />
                                <p>
                                  Drag and drop or <span>browse for a file</span>
                                  <br />
                                </p>
                                <div className="acceptedFiles">
                                  .csv only <span>10MB</span> max file size
                                </div>
                              </div>
                            </section>
                            {/* <div className="DownLoadTemplateLink">
                                                <a className="templateLink" onClick={this.downloadTemplate}>Download Template</a>
                                            </div> */}
                          </>
                        )}
                        {this.state.uploadFiles.length > 0 && (
                          <aside className="d-flex flex-column file-list">
                            <ul>{files}</ul>
                          </aside>
                        )}
                      </>
                    )}
                  </Dropzone>
                  {/* ) */}

                </div>

                {this.state.fileUploadedError_msg !== "" && (
                  <div className="error">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                      <path d="M7.00065 4.16671C7.36732 4.16671 7.66732 4.46671 7.66732 4.83337V7.50004C7.66732 7.86671 7.36732 8.16671 7.00065 8.16671C6.63398 8.16671 6.33398 7.86671 6.33398 7.50004V4.83337C6.33398 4.46671 6.63398 4.16671 7.00065 4.16671ZM6.99398 0.833374C3.31398 0.833374 0.333984 3.82004 0.333984 7.50004C0.333984 11.18 3.31398 14.1667 6.99398 14.1667C10.6807 14.1667 13.6673 11.18 13.6673 7.50004C13.6673 3.82004 10.6807 0.833374 6.99398 0.833374ZM7.00065 12.8334C4.05398 12.8334 1.66732 10.4467 1.66732 7.50004C1.66732 4.55337 4.05398 2.16671 7.00065 2.16671C9.94732 2.16671 12.334 4.55337 12.334 7.50004C12.334 10.4467 9.94732 12.8334 7.00065 12.8334ZM7.66732 10.8334H6.33398V9.50004H7.66732V10.8334Z" fill="#D3412E" />
                    </svg>
                    {this.state.fileUploadedError_msg}
                  </div>
                )}


              </div>
            </div>
          )}
          {this.state.isUploadesFiles && (
            <div className="content">


              <BootstrapTable
                // {...props.baseProps}
                id="LocationBulkUploadData"
                keyField="location-tbl"
                data={this.state.bulkUplodedFilesData}
                columns={columns}
                hover
              // selectRow={caSelectRow}
              //   rowClasses={rowClasses}
              //     headerClasses={
              //       this.state.isAdded
              //         ? "checkbox-disabled"
              //         : ""
              //     }
              />
            </div>
          )}

        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={this.handleBackScreen}
            className="btn-outline-primary btn btn-primary mr-auto"
          >
            Back
          </button>
          <Button
            type="button"
            onClick={this.handleOnCancel}
          >
            Cancel
          </Button>
          <Button
            disabled={(this.state.isUploadesFiles && this.state.bulkUplodedFilesData.length === 0) ||
              !this.state.isFileUploadedError || this.state.isImportData }
            variant="primary"
            onClick={(e) => { this.handleCSVImportData(this.state.isUploadesFiles ? "ImportData" : "Next") }}
          >
            {this.state.isImportData && (
              <>
                <Spinner size="sm" animation="border" />{" "}
              </>
            )}{" "}
            {this.state.isUploadesFiles ? "Import" : "Next"}

          </Button>
        </Modal.Footer>
      </Modal>

    )
  }
}